import React, { Component } from "react";
import { Form, Image, Input, Select, TextArea } from "semantic-ui-react";
import "../assets/styles/contact.scss";
import Tom from "../assets/images/tom.png";
import axios from "axios";
import { contactDetailEndpoint } from "../constants";
import { Formik } from "formik";
import * as Yup from "yup";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import qs from "qs";

const validationSchema = Yup.object({
  name: Yup.string()
    .max(45, "Name is Too Long")
    .min(2, "Name is Too Short")
    .required("Required"),
  email: Yup.string().email("Invalid Email Address").required("Required"),
  phone: Yup.string().matches(/^[6789]\d{9}$/, "Invalid Mobile"),
  message: Yup.string().required("Enter the Message"),
});

class Contact extends Component {
  constructor() {
    super();

    this.state = {
      loading: false,
      name: "",
      email: "",
      phone: "",
      domain: "",
      message: "",
    };
  }

  render() {
    return (
      <div className={"contact"}>
        <Formik
          initialValues={{
            name: "",
            email: "",
            phone: "",
            domain: "PR",
            message: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            this.setState({ loading: true });

            const { name, email, phone, domain, message } = values;

            axios
              .post(
                contactDetailEndpoint,
                qs.stringify({
                  name,
                  email,
                  phone,
                  domain,
                  message,
                }),
                {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                }
              )
              .then((res) => {
                toast({
                  title: "Success",
                  description: "Your Response has been recorded",
                  type: "success",
                });
                this.setState({ loading: false });
              })
              .catch((err) => {
                toast({
                  title: "Error",
                  description: "There was an error. Please Try again later",
                  type: "error",
                });
                this.setState({ loading: false });
              });
          }}
          validateOnChange={true}
          validateOnBlur={false}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <Form className={"contact-form"}>
              <Form.Group>
                <Form.Field
                  name={"name"}
                  error={
                    touched.name &&
                    errors.name && {
                      content: errors.name,
                    }
                  }
                  //error={touched.name && errors.name && errors.name !== ""}
                  control={Input}
                  onChange={handleChange}
                  value={values.name}
                  placeholder={"Full Name"}
                  fluid
                  width={16}
                />
              </Form.Group>

              <Form.Group>
                <Form.Field
                  name={"email"}
                  error={
                    touched.email &&
                    errors.email && {
                      content: errors.email,
                    }
                  }
                  //error={touched.email && errors.email && errors.email !== ""}
                  control={Input}
                  onChange={handleChange}
                  value={values.email}
                  placeholder={"Email"}
                  fluid
                  width={8}
                />
                <Form.Field
                  name={"phone"}
                  error={
                    touched.phone &&
                    errors.phone && {
                      content: errors.phone,
                    }
                  }
                  //error={touched.phone && errors.phone && errors.phone !== ""}
                  control={Input}
                  onChange={handleChange}
                  value={values.phone}
                  placeholder={"Phone Number"}
                  fluid
                  width={8}
                />
              </Form.Group>

              <Form.Group>
                <Form.Field
                  name={"domain"}
                  error={
                    touched.domain &&
                    errors.domain && {
                      content: errors.domain,
                    }
                  }
                  //error={touched.domain && errors.domain && errors.domain !== ""}
                  className="select-reason"
                  control={"Select"}
                  placeholder={"Reason of Contacting"}
                  fluid
                  width={16}
                  onChange={handleChange}
                  value={values.domain}
                >
                  <option value={"PR"}>Public Relation</option>
                  <option value={"Sponsorship"}>Sponsorship</option>
                  <option value={"Shows"}>Proshows</option>
                  <option value={"Finance"}>Finance</option>
                  <option value={"Workshop"}>Workshops</option>
                  <option value={"social_cause"}>Social Cause</option>
                  <option value={"Culti"}>Culti</option>
                  <option value={"Biggies"}>Biggies</option>
                  <option value={"Techy"}>Techy</option>
                  <option value={"Informals"}>Informals</option>
                  <option value={"Merch"}>Merch</option>
                  <option value={"Miscellaneous"}>Miscellaneous</option>
                </Form.Field>
              </Form.Group>

              <Form.Group>
                <Form.Field
                  name={"message"}
                  error={
                    touched.message &&
                    errors.message && {
                      content: errors.message,
                    }
                  }
                  //error={touched.message && errors.message && errors.message !== ""}
                  control={TextArea}
                  onChange={handleChange}
                  value={values.message}
                  placeholder={"Your Message"}
                  fluid
                  width={16}
                />
              </Form.Group>

              <Form.Button
                disabled={this.state.loading}
                loading={this.state.loading}
                onClick={handleSubmit}
              >
                SUBMIT
              </Form.Button>
            </Form>
          )}
        </Formik>

        <Image src={Tom} className={"tom-img"} />
      </div>
    );
  }
}

export default Contact;
